<template>
<div id="upimg">
     <!-- 头部组件 -->
     <component :is="header_"></component>
     <!--  -->
    <el-container class="el-container-box" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>

      <el-container>
        <div class="it1024im-upload-box">
          <div class="upload-box">
            <div class="upload-max">
               <div class="kefuziliao">客服资料</div>
               <div class="it1024im-ziliao-center">
                  <ul>
                    <li style="position: relative;">
                       <img v-if="KfimageUrl" :src="KfimageUrl" style="width:60px;margin-top:19px;margin-bottom: 13px;border-radius: 50%;">
                       <img v-else style="width:60px;margin-top:19px;margin-bottom: 13px;border-radius: 50%;" :src="it1024imURL+'/php/upimg/it1024im-kefuimg.png'">
                      <el-upload
                        class="avatar-uploader"
                        :data="{'kefu':'kefu'}"
                        :action="upimgurl"
                        :show-file-list="false"
                        :on-success="KfhandleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="false" :src="KfimageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </li>
                    <li>
                       <input type="text" placeholder="客服">
                    </li>
                  </ul>
               </div>
            </div>
            <div class="upload-max">
               <div class="kefuziliao">访客资料</div>
               <div class="it1024im-ziliao-center">
                  <ul>
                    <li style="position: relative;">
                       <img v-if="imageUrl" :src="imageUrl" style="width:60px;margin-top:19px;margin-bottom: 13px;border-radius: 50%;">
                       <img v-else style="width:60px;margin-top:19px;margin-bottom: 13px;border-radius: 50%;" :src="it1024imURL+'/php/upimg/it1024im-fangkeimg.png'">
                      <el-upload
                        class="avatar-uploader"
                        :data="{'fangke':'fangke'}"
                        :action="upimgurl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="false" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </li>
                    <li>
                       <input type="text" placeholder="访客">
                    </li>
                  </ul>
               </div>
            </div>
          </div>

        </div>

      </el-container>
    </el-container>
</div>
</template>

<script>
//全局属性
import global from '@/common/common.vue'
//头部组件
import header_ from './header_.vue'
import celan from './celan.vue'
export default {
  name: 'upimg',
   data() {
      return {
        header_:header_,
        celan:celan,
        KfimageUrl: '',
        imageUrl: '',
        it1024imURL: global.it1024imURL,
        upimgurl: global.it1024imUrl,
      }
    },
     methods: {
        KfhandleAvatarSuccess(res, file) {
          this.KfimageUrl = URL.createObjectURL(file.raw);
        },        
        handleAvatarSuccess(res, file) {
          this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
          const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
          const isLt2M = file.size / 1024 / 1024 < 2;

          if (!isJPG) {
            this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
          }
          if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
          }
          return isJPG && isLt2M;
        }


    },
    created(){

       
    }
}
</script>


<style scoped>
.el-container-box,#upimg {
    height: 100%;
}
.el-container {
    background: #f3f5fb;
}
.upload-box {
    width: 100%;
    margin-top: 1rem;
}
.upload-max {
    background: #ffffff;
    box-shadow: 0 2px 20px 0 rgba(0,0,0,.05);
    border-radius: 12px;
    width: 100%;
    height: 188px;
    margin-bottom: 15px;
}

.kefuziliao {
    font-weight: bold;
    height: 39px;
    line-height: 39px;
    margin-left: 10px;
}

.it1024im-ziliao-center {
    text-align: center;
}
.it1024im-ziliao-center input{
    text-align: center;
    width: 100%;
    border: none;
    outline: none;
}
.it1024im-ziliao-center ul li{
          list-style: none;
    width: 50%;
    margin: 0 auto;
}
.avatar-uploader {
    display: inline-block;
}
.el-icon-plus.avatar-uploader-icon {
position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    opacity: 0;
}
.it1024im-upload-box{
  width: 100%;
    height: 100%;
}
@media screen and (min-width: 800px) {
  .upload-box {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-evenly;
    text-align: center;
    -webkit-box-align: baseline;
  }
  .upload-max {
    width: 45%;
  }
  .kefuziliao {
    float: left;
  }
  .it1024im-ziliao-center {
    clear: both;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/upimg.vue